import html2Canvas from 'html2canvas'
import JSPDF from 'jspdf'
import { toJpeg } from 'html-to-image'

const base64ToFile = (urlData, fileName) => {
  const arr = urlData.split(',')
  const type = arr[0].match(/:(.*?);/)[1]
  const fileExt = type.split('/')[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], fileName + '.' + fileExt, {
    type
  })
}

export const downloadPdf = (pdf, filename) => {
  return pdf.save(filename + '.pdf')
}

export const createPdfFile = (pdf, filename) => {
  const output = pdf.output('dataurlstring')
  return base64ToFile(output, filename)
}

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = async function (
      elementClass,
      size = 'a4',
      direction = 'p'
    ) {
      const pages = document.querySelectorAll(elementClass)
      let top = pages[0]
      if (top != null) {
        top.scrollIntoView()
        top = null
      }
      let width
      let height
      let adjustW
      let adjustH
      let adjustL
      let adjustT
      if (size === 'a4') {
        width = 595
        height = 844.3
        adjustW = -20
        adjustH = -20
        adjustL = 10
        adjustT = 10

        if (direction === 'l') {
          ;[width, height] = [height, width]
          adjustW = -150
          adjustH = -60
          adjustL = 120
          adjustT = 20
        }
      } else if (size === 'small label') {
        width = 288
        height = 180
        adjustW = -40
        adjustH = -40
        adjustL = 20
        adjustT = 38
        // adjustT = 10
      } else if (size === 'label') {
        width = 288
        height = 432
        adjustW = 0
        adjustH = 0
        adjustL = 0
        adjustT = 0
      }
      const imgWidth = width + adjustW
      const imgHeight = height + adjustH
      const pageWidth = width
      const pageHeight = height

      const PDF = new JSPDF(direction, 'pt', [pageWidth, pageHeight])

      for (let i = 0; i < pages.length; i++) {
        if (i > 0) PDF.addPage()
        PDF.setPage(i + 1)
        const page = pages[i]
        const pageData = await toJpeg(page, {
          quality: 1,
          cacheBust: true,
          pixelRatio: window.devicePixelRatio,
          backgroundColor: 'white',
          skipFonts: true,
          fontEmbedCSS: '',
          filter: notMapbox
        })
        PDF.addImage(pageData, 'JPEG', adjustL, adjustT, imgWidth, imgHeight)
      }

      return PDF
    }
    Vue.prototype.ExportSavePdf = async function (htmlTitle, currentTime) {
      const pdf = new JSPDF('l', 'mm', 'a4')
      const labels = document.getElementsByClassName('print-label')
      for (let i = 0; i < labels.length; i++) {
        const canvas = await html2Canvas(labels[i], {
          allowTaint: true,
          scale: 1,
          logging: false
        })
        const ctx = canvas.getContext('2d')
        const a4h = 170
        const a4w = 257
        const imgHeight = Math.floor((a4h * canvas.width) / a4w)
        const page = document.createElement('canvas')
        page.width = canvas.width
        page.height = Math.min(imgHeight, canvas.height)
        page
          .getContext('2d')
          .putImageData(
            ctx.getImageData(
              0,
              0,
              canvas.width,
              Math.min(imgHeight, canvas.height)
            ),
            0,
            0
          )
        pdf.addImage(
          page.toDataURL('image/jpeg', 1.0),
          'JPEG',
          20,
          20,
          a4w,
          Math.min(a4h, (a4w * page.height) / page.width)
        )
        if (i !== labels.length - 1) pdf.addPage()
      }
      pdf.save(htmlTitle + currentTime)
    }
  }
}

function notMapbox(node) {
  if (!node) return true
  if (node.classList && node.classList.contains('mapboxgl-map')) return false
  if (node.closest && node.closest('.mapboxgl-map')) return false
  return true
}
